/* ---------------- passaggi di rifinitura: un solo osservatore ----------------
   Ogni ritocco (icone, swatch, tessere, upload, riepilogo taglie) osservava il
   documento per conto proprio e riapplicava le sue modifiche: le mutazioni di
   uno risvegliavano gli altri e la pagina "sfarfallava". Qui i passaggi sono
   registrati in una coda unica, eseguita al massimo una volta per frame con
   l'osservatore staccato mentre gira. */
window.WSPDP_pass=(function(){
var passi=[],inCorso=false,programmato=false,obs=null,root=document.body;
function esegui(){
programmato=false;
if(inCorso)return;
inCorso=true;
if(obs)obs.disconnect();
for(var i=0;i<passi.length;i++){try{passi[i]()}catch(e){console.error('[wow-pdp] passaggio:',e)}}
inCorso=false;
if(obs&&root)obs.observe(root,{childList:true,subtree:true});
}
/* finché il preloader anima il logo lasciamo il thread libero: i nostri
   passaggi leggono la geometria e bloccherebbero l'animazione per qualche ms */
function preloaderAttivo(){
var pl=document.getElementById('wow-preloader');
return !!(pl&&!pl.classList.contains('hide'));
}
function programma(){
if(programmato||inCorso)return;
programmato=true;
if(preloaderAttivo()){
var attesa=setInterval(function(){
if(preloaderAttivo())return;
clearInterval(attesa);
requestAnimationFrame(esegui);
},120);
setTimeout(function(){clearInterval(attesa);requestAnimationFrame(esegui)},3000);
return;
}
requestAnimationFrame(esegui);
}
obs=new MutationObserver(programma);
if(root)obs.observe(root,{childList:true,subtree:true});
document.addEventListener('DOMContentLoaded',programma);
window.addEventListener('load',programma);
window.addEventListener('resize',programma);
return function(fn){passi.push(fn);programma();return programma};
})();

/* la pagina prodotto usa le misure del progetto, non quelle del tema */
try{document.body.classList.add("ws-pdp-body")}catch(e){}
/* WowStampa — PDP Kit promo
   Wizard 4 step + ponte con le app: VOPO (opzioni/varianti), Upload Lift,
   Anteprima di Stampa, wowstampa-reviews-app.
   Le select native di Shopify/VOPO restano la fonte di verità: i pulsanti
   grafici scrivono lì dentro e reagiscono al loro evento change. */
(function(){
var form=document.getElementById('ws-form');if(!form)return;
var root=form.closest('.wow-pdp-kit')||document;
var $=function(id){return document.getElementById(id)};
var data={variants:[],ctas:['Continua','Continua','Continua','Aggiungi al carrello']};
try{data=JSON.parse($('ws-variants').textContent)||data}catch(e){}

/* ---------------- varianti ---------------- */
var NATIVE_SEL='select.single-option-selector[name^="options["]';
function nativeSelects(){return [].slice.call(form.querySelectorAll(NATIVE_SEL))}
function selectedOptions(){
return nativeSelects().map(function(s){return s.value});
}
function findVariant(){
var sel=selectedOptions();
if(!sel.length)return data.variants[0];
return data.variants.filter(function(v){
return v.options.length===sel.length&&v.options.every(function(o,i){return o===sel[i]});
})[0];
}
function applyVariant(){
var v=findVariant();
var go=$('btn-go');
if(!v){
if(go){go.disabled=true;go.textContent='Combinazione non disponibile'}
return;
}
$('ws-variant-id').value=v.id;
var price=v.price_f,save=(v.compare&&v.compare>v.price)?v.compare-v.price:0;
[['hero-now',price],['bar-tot',price],['sum-tot',price]].forEach(function(p){
var el=$(p[0]);if(el)el.textContent=p[1];
});
var was=$('hero-was');if(was)was.textContent=v.compare_f||'';
if(was)was.hidden=!save;
var hs=$('hero-save');
if(hs){hs.hidden=!save;if(save)hs.textContent='Risparmi '+money(save)}
var bu=$('bar-unit');
if(bu&&save)bu.textContent='Risparmi '+money(save);
if(go){go.disabled=!v.available;if(!v.available)go.textContent='Esaurito';else if(cur===4)go.textContent=data.ctas[3];}
markUnavailable();
if(window.WSPDP_totals)WSPDP_totals();
}
function money(cents){
var sample=(data.variants[0]&&data.variants[0].price_f)||'€0,00';
var n=(cents/100).toLocaleString('it-IT',{minimumFractionDigits:2,maximumFractionDigits:2});
return sample.indexOf('€')===0?('€'+n):(n+' €');
}
/* opzioni non acquistabili: barrate ma cliccabili */
function markUnavailable(){
var sels=nativeSelects();
if(!sels.length)return;
sels.forEach(function(sel,idx){
var wrap=sel.closest('.selector-wrapper');if(!wrap)return;
wrap.querySelectorAll('.opt').forEach(function(b){
var combo=sels.map(function(s,i){return i===idx?b.dataset.v:s.value});
var ok=data.variants.some(function(v){
return v.available&&v.options.every(function(o,i){return o===combo[i]});
});
b.classList.toggle('is-off',!ok);
});
});
}

/* ---------------- opzioni: pulsanti <-> select ---------------- */
var OPT_SEL='select.single-option-selector, select[data-option], select[name^="properties["]';
/* mini-illustrazione dedotta dall'etichetta */
var VIZ=[[/rifilo/i,'trim'],[/occhiell/i,'eyelet'],[/asola superiore|asola sup/i,'hem-t'],[/asole? vertical/i,'hem-tb'],[/asole? lateral/i,'hem-lr'],[/microfor|rete/i,'mesh']];
function vizNode(label){
var c='';for(var i=0;i<VIZ.length;i++){if(VIZ[i][0].test(label)){c=VIZ[i][1];break}}
if(!c)return null;
if(c==='eyelet'){
var s=document.createElementNS('http://www.w3.org/2000/svg','svg');
s.setAttribute('viewBox','0 0 46 22');s.setAttribute('aria-hidden','true');s.setAttribute('class','viz-fin eyelet');
s.innerHTML='<rect x="1" y="1" width="44" height="20" rx="3"></rect><g class="ey">'+[[5,5],[16,5],[30,5],[41,5],[5,17],[16,17],[30,17],[41,17],[5,11],[41,11]].map(function(p){return '<circle cx="'+p[0]+'" cy="'+p[1]+'" r="1.7"></circle>'}).join('')+'</g>';
return s;
}
var sp=document.createElement('span');sp.className='viz-fin '+c;sp.setAttribute('aria-hidden','true');return sp;
}
var OPT_DESC={
'solo rifilo':'Taglio netto senza rinforzi',
'rinforzo ed occhielli':'Bordi rinforzati con occhielli ogni 50 cm',
'asola superiore':'Asola rinforzata sul lato superiore',
'asole verticali':'Asole rinforzate su lati superiore e inferiore',
'asole laterali':'Asole rinforzate sui lati destro e sinistro'
};
function norm(s){return (s||'').toLowerCase().replace(/[×x]/g,'x').replace(/\s+/g,' ').trim()}
function isPrintPosition(w){
var t=w&&w.querySelector('.bcpo-title');
var label=t?t.textContent:'';
return /posizion[ei] stampa|lati di stampa|stampa su/i.test(label);
}
function restoreNativeSelect(w,sel){
w.querySelectorAll('.opts,.ws-dd').forEach(function(el){el.remove()});
w.removeAttribute('data-ws-skinned');
w.classList.add('ws-native-select');
if(!sel)return;
sel.hidden=false;
sel.removeAttribute('hidden');
sel.removeAttribute('aria-hidden');
sel.removeAttribute('tabindex');
sel.style.removeProperty('display');
}
/* l'app rende <select> nudi: ci disegno sopra i pulsanti del tema */
function isSize(v){return /\d+\s*[x×]\s*\d+/.test(v)}
function buildOpts(w,sel){
var vals=[].slice.call(sel.options).filter(function(o){return !!o.value});
var sizes=vals.length&&vals.every(function(o){return isSize(o.value)});
var box=document.createElement('div');
box.className=sizes?'opts':'opts rows';
box.setAttribute('role','group');
box.setAttribute('aria-label',((w.querySelector('.bcpo-title')||{}).textContent||'Opzioni').replace(/:\s*$/,''));
vals.forEach(function(o){
var label=o.textContent.trim();
var b=document.createElement('button');
b.type='button';b.dataset.v=o.value;
b.setAttribute('aria-pressed',String(o.selected));
if(sizes){
b.className='opt viz';
var m=label.match(/(\d+)\s*[x×]\s*(\d+)/);
var rup=document.createElement('span');
rup.className='viz-rup';
rup.style.setProperty('--w',Math.round((m?+m[1]:80)*0.29)+'px');
rup.setAttribute('aria-hidden','true');
b.appendChild(rup);
var big=document.createElement('b');
big.textContent=m?(m[1]+'×'+m[2]):label;
b.appendChild(big);
var unit=label.replace(/[\d\s]*[x×][\d\s]*/,'').trim();
if(unit){var u=document.createElement('small');u.textContent=unit;b.appendChild(u)}
}else{
b.className='opt row';
var viz=vizNode(label);if(viz)b.appendChild(viz);
var t=document.createElement('span');t.className='row-t';
var strong=document.createElement('b');strong.textContent=label.split('·')[0].trim();
t.appendChild(strong);
var desc=o.getAttribute('data-desc')||OPT_DESC[norm(label)]||label.split('·').slice(1).join('·').trim();
if(desc){var sm=document.createElement('small');sm.textContent=desc;t.appendChild(sm)}
b.appendChild(t);
}
box.appendChild(b);
});
sel.parentNode.insertBefore(box,sel);
return box;
}
function bindOptions(scope){
(scope||document).querySelectorAll('.selector-wrapper').forEach(function(w){
var sel=w.querySelector(OPT_SEL);
if(!sel)return;
if(isPrintPosition(w)){
restoreNativeSelect(w,sel);
return;
}
if(!w.querySelector('.opt')&&sel.options.length)buildOpts(w,sel);
if(!w.querySelector('.opt'))return;
sel.hidden=true;
sel.style.display='none';
if(!w.dataset.wsBound){
w.dataset.wsBound='1';w.setAttribute('data-ws-bound','1');
w.addEventListener('click',function(e){
var b=e.target.closest('.opt');if(!b||!w.contains(b))return;
e.preventDefault();
e.stopPropagation();
if(sel.value!==b.dataset.v){
sel.value=b.dataset.v;
sel.dispatchEvent(new Event('input',{bubbles:true}));
sel.dispatchEvent(new Event('change',{bubbles:true}));
}
reflect(w,sel);
});
sel.addEventListener('change',function(){reflect(w,sel);applyVariant();paint()});
w.addEventListener('click',function(e){if(e.target.closest('.opt'))setTimeout(function(){applyVariant();paint()},0)});
}
reflect(w,sel);
});
}
/* le opzioni Shopify viaggiano nell'id variante: le ripeto come line item
   property così compaiono anche stampate nel carrello e in ordine/packing */
function mirrorProps(){
nativeSelects().forEach(function(sel){
var nome=(sel.name.match(/\[(.*)\]/)||[])[1]||sel.getAttribute('aria-label')||'';
if(!nome)return;
var id='ws-prop-'+nome.toLowerCase().replace(/[^a-z0-9]+/g,'-');
var inp=document.getElementById(id);
if(!inp){
inp=document.createElement('input');
inp.type='hidden';
inp.id=id;
inp.name='properties['+nome+']';
form.appendChild(inp);
}
inp.value=sel.value||'';
});
}
window.WSPDP_mirrorProps=mirrorProps;

function reflect(w,sel){
mirrorProps();
var val=sel.value;
w.querySelectorAll('.opt').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.v===val))});
var lab=w.querySelector('[data-val]');
if(lab&&lab.textContent!==val)lab.textContent=val;
}

/* ---------------- app: sposto i blocchi negli slot ---------------- */
function hostFor(node){
if(node.querySelector('.single-option-selector,.selector-wrapper,.bcpo-label,[class*="product-option"]'))return $('ws-bcpo-slot');
if(node.querySelector('.cl-upload--wrapper,.filepond--root,[data-upload-lift],[data-uploadlift]'))return document.querySelector('#ws-upload-slot .upload-lift-host');
if(node.querySelector('[data-ws-proof],[data-anteprima],[class*="anteprima"]'))return $('ws-proof-slot');
return null;
}
function placeAppBlocks(){
var box=$('ws-app-blocks');if(!box)return;
[].slice.call(box.children).forEach(function(node){
var host=hostFor(node);
if(host){host.appendChild(node);node.classList.add('shopify-app-block')}
});
box.hidden=box.children.length===0?true:box.hidden;
}
/* Upload Lift monta spesso fuori dal form: lo riporto nello slot */
function isOurs(el){return !!(el.closest('.ws-native-upload')||el.querySelector&&el.querySelector('[data-up]')||el.matches('[data-up]'))}
function captureUploadLift(){
var host=document.querySelector('#ws-upload-slot .upload-lift-host');if(!host)return false;
/* solo i box veri dell'app: quelli con un FilePond dentro */
var live=[].slice.call(document.querySelectorAll('.filepond--root')).filter(function(n){return !isOurs(n)});
live.forEach(function(n){
var box=n.closest('.cl-upload--wrapper')||n.closest('.upload-container')||n.closest('.shopify-app-block')||n;
if(!host.contains(box))host.appendChild(box);
});
/* i nostri box di fallback tornano al loro posto e restano nascosti */
var fb=document.querySelector('#ws-upload-slot .ws-native-upload');
if(fb)host.querySelectorAll('[data-up]').forEach(function(inp){
var w=inp.closest('.up-field')||inp.closest('.cl-upload--wrapper');
if(w&&!fb.contains(w))fb.appendChild(w);
});
return !!host.querySelector('.filepond--root');
}
function syncUploadUI(){
var native=document.querySelector('#ws-upload-slot .ws-native-upload');
var live=document.querySelector('#ws-upload-slot .filepond--root');
if(native)native.hidden=!!live;
/* con l'app attiva restano visibili solo i suoi box */
document.querySelectorAll('#ws-upload-slot .cl-upload--wrapper').forEach(function(w){
if(!live)return;
w.hidden=!w.querySelector('.filepond--root');
});
}

/* ---------------- upload fallback (senza app) ---------------- */
var files={rollup:[],banner:[]},later=false;
function drawFiles(){
Object.keys(files).forEach(function(k){
var list=form.querySelector('[data-list="'+k+'"]');if(!list)return;
list.innerHTML='';
files[k].forEach(function(f,i){
var li=document.createElement('li');
li.innerHTML='<i>✓</i><span></span><button type="button" aria-label="Rimuovi file">Rimuovi</button>';
li.querySelector('span').textContent=f;
li.querySelector('button').addEventListener('click',function(){files[k].splice(i,1);drawFiles();paint()});
list.appendChild(li);
});
var inp=form.querySelector('[data-up="'+k+'"]');
var c=inp&&inp.closest('.cl-upload--wrapper').querySelector('[data-count]');
if(c)c.textContent=files[k].length+'/3';
});
}
form.querySelectorAll('[data-up]').forEach(function(inp){
inp.addEventListener('change',function(){
var k=inp.dataset.up;
[].slice.call(inp.files).forEach(function(f){if(files[k].length<3)files[k].push(f.name)});
inp.value='';drawFiles();paint();hideErr();
});
});
var upLater=$('up-later');
if(upLater)upLater.addEventListener('change',function(){later=upLater.checked;paint();hideErr()});

/* file caricati dall'app: contati dalle line item properties che inserisce */
function appFileCount(){
return form.querySelectorAll('input[type="hidden"][name^="properties"][value^="http"]').length
     + document.querySelectorAll('#ws-upload-slot .filepond--item').length;
}
function totalFiles(){return files.rollup.length+files.banner.length+appFileCount()}

/* ---------------- anteprima di stampa ---------------- */
var proof='no';
/* abbigliamento: l'anteprima è sempre inclusa, nessuna scelta da fare.
   Se il Liquid non ha ancora prodotto il riquadro fisso ma il metafield dice
   abbigliamento, lo costruiamo qui sostituendo i due pulsanti. */
(function(){
var slot=$('ws-proof-slot');
if(!slot)return;
var val=(slot.getAttribute('data-ws-anteprima')||'').toLowerCase();
/* se il Liquid non ha ancora stampato il valore, guardiamo i tag prodotto:
   VOPO li pubblica in window.bcpo_product, quindi non serve ricaricare nulla */
if(val.indexOf('abbigliament')<0){
try{
var tag=(window.bcpo_product&&window.bcpo_product.tags||[]).join(' ').toLowerCase();
if(tag.indexOf('abbigliament')>=0)val=tag;
}catch(e){}
}
console.log('[wow-pdp] anteprima di stampa · valore:',JSON.stringify(val),'· tipo metafield:',slot.getAttribute('data-ws-anteprima-tipo'));
if(val.indexOf('abbigliament')<0)return;
var box=slot.querySelector('.proof-yn');
if(!box||box.hasAttribute('data-proof-fixed'))return;
box.classList.add('proof-yn--fixed');
box.setAttribute('data-proof-fixed','yes');
box.innerHTML='<div class="yn yes is-fixed" aria-pressed="true" data-proof="yes"><b>Sempre inclusa</b><small>Ricevi l\'anteprima prima della stampa e la approvi tu. Nessun costo.</small></div>';
})();
if(form.querySelector('[data-proof-fixed]')){
proof='yes';
var pnFix=$('proof-note');if(pnFix)pnFix.classList.add('is-on');
}
form.querySelectorAll('[data-proof]').forEach(function(b){
b.addEventListener('click',function(e){
e.preventDefault();
e.stopPropagation();
form.querySelectorAll('[data-proof]').forEach(function(o){o.setAttribute('aria-pressed','false')});
b.setAttribute('aria-pressed','true');
proof=b.dataset.proof;
var pn=$('proof-note');if(pn)pn.classList.toggle('is-on',proof==='yes');
paint();hideErr();
});
});

/* ---------------- riepilogo ---------------- */
function paint(){
var sum=$('ws-sum');if(!sum)return;
/* righe opzione generate dalle select reali */
sum.querySelectorAll('[data-ws-opt]').forEach(function(n){n.remove()});
var anchor=sum.querySelector('#sum-file')?sum.querySelector('#sum-file').closest('li'):null;
/* Una riga per ogni gruppo di opzioni, qualunque controllo usi: le select
   native, i radio delle pastiglie colore, i campi quantità delle taglie.
   Il valore corrente lo pubblica .bcpo-value (per le taglie lo scriviamo noi). */
document.querySelectorAll('#ws-bcpo-slot .selector-wrapper, #ws-form .selector-wrapper').forEach(function(w){
var t=w.querySelector('.bcpo-title');
var name=((t&&t.textContent)||'').replace(/:\s*$/,'').trim();
if(!name)return;
var valore='';
var v=w.querySelector('.bcpo-value');
if(v&&!v.hidden)valore=(v.textContent||'').trim();
if(!valore){
var sel=w.querySelector(OPT_SEL)||w.querySelector('select');
if(sel)valore=sel.value||'';
}
if(!valore){
var r=w.querySelector('input[type=radio]:checked');
if(r)valore=r.value||'';
}
if(!valore)return;
var li=document.createElement('li');
li.setAttribute('data-ws-opt','');
li.innerHTML='<span></span><b></b>';
li.querySelector('span').textContent=name;
li.querySelector('b').textContent=valore;
if(anchor)sum.insertBefore(li,anchor);else sum.appendChild(li);
});
var n=totalFiles();
var sf=$('sum-file');
if(sf)sf.textContent=n?(n+(n===1?' file caricato':' file caricati')):(later?'Invio dopo l\'ordine':'Nessun file');
var sp=$('sum-proof');
if(sp){
if(form.querySelector('[data-proof-fixed]'))sp.textContent='Sì - Gratuita';
else sp.textContent=proof==='yes'?(data.proof&&data.proof.price_f?'Sì · '+data.proof.price_f:'Sì'):'No';
}
var pp=$('prop-proof');
if(pp){
if(form.querySelector('[data-proof-fixed]')){
pp.disabled=false;
pp.value='Sì - Gratuita';
}else if(data.proof&&data.proof.id){
/* con il prodotto configurato l'anteprima è una riga di carrello a sé:
   niente line item property sul kit */
pp.disabled=true;
pp.value='';
}else{
pp.disabled=false;
pp.value=proof==='yes'?'Sì · gratuita':'No';
}
}
var msg=$('proof-msg');if(msg)msg.disabled=proof!=='yes';
}

/* ---------------- wizard ---------------- */
var cur=1;
var panels=[].slice.call(form.querySelectorAll('.panel'));
var steps=[].slice.call(form.querySelectorAll('#wz-steps li'));
var btnGo=$('btn-go'),btnBack=$('btn-back');
function hideErr(){form.querySelectorAll('.err').forEach(function(e){e.classList.remove('is-on')})}
function valid(n){
if(n===1){
var st=window.WSPDP_sizesState&&WSPDP_sizesState();
if(st&&!st.ok){
var box=document.querySelector('.ws-sizes');
var err=box&&box.querySelector('.ws-sizes__error');
if(err){err.textContent=st.msg;err.hidden=false}
return false;
}
}
if(n===2)return totalFiles()>0||later;
return true;
}
/* Su mobile il configuratore non è a step: tutte le card restano aperte in
   colonna e la CTA è direttamente "Aggiungi al carrello" (i clienti sono
   abituati al configuratore intero). */
var PIATTO=window.matchMedia('(max-width:899px)');
function piatto(){return PIATTO.matches}
function show(n,silent){
if(piatto())n=4;
cur=n;
panels.forEach(function(p){p.classList.toggle('is-on',piatto()||+p.dataset.step===n)});
steps.forEach(function(li,i){li.dataset.state=i+1<n?'done':(i+1===n?'now':'todo')});
btnBack.hidden=n===1;
btnGo.innerHTML=(n===4||piatto())?data.ctas[3]:data.ctas[n-1]+' <span class="ar">→</span>';
/* fino allo step 4 non è un submit: gli script del tema e delle app
   agganciano l'add-to-cart al click su [type=submit][name=add] */
if(n===4){btnGo.type='submit';btnGo.setAttribute('name','add')}
else{btnGo.type='button';btnGo.removeAttribute('name')}
var lab=$('bar-lab');if(lab)lab.textContent=n===4?'Totale':'Totale stimato';
var bp=form.querySelector('.bar-p');if(bp)bp.hidden=n===4;
form.querySelector('.bar').classList.toggle('bar--final',n===4);
hideErr();
if(window.innerWidth<900&&!silent&&!piatto()){
var top=form.getBoundingClientRect().top+window.pageYOffset-8;
window.scrollTo({top:top,behavior:'smooth'});
}
}

/* rete di sicurezza: qualsiasi submit prima dello step 4 viene bloccato */
form.addEventListener('submit',function(e){
if(cur<4){e.preventDefault();e.stopImmediatePropagation()}
},true);
btnBack.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(cur>1)show(cur-1)});
steps.forEach(function(li,i){li.style.cursor='pointer';li.addEventListener('click',function(){if(i+1<cur)show(i+1)})});

/* ---------------- galleria ---------------- */
root.querySelectorAll('.gal-thumbs button').forEach(function(b){
b.addEventListener('click',function(){
root.querySelectorAll('.gal-thumbs button').forEach(function(o){o.setAttribute('aria-pressed','false')});
b.setAttribute('aria-pressed','true');
root.querySelectorAll('.gal-shot').forEach(function(s){s.classList.toggle('is-on',s.dataset.shot===b.dataset.shot)});
});
});

/* ---------------- countdown ---------------- */
var cd=$('cd');
if(cd){
var attr=cd.getAttribute('data-deadline');
function tick(){
var now=new Date(),end;
if(attr){end=new Date(attr);if(isNaN(end))end=null}
if(!end||end<=now){end=new Date(now);end.setHours(24,0,0,0)}
var s=Math.max(0,Math.floor((end-now)/1000)),p=function(x){return String(x).padStart(2,'0')};
cd.querySelector('[data-h]').textContent=p(Math.floor(s/3600));
cd.querySelector('[data-m]').textContent=p(Math.floor(s%3600/60));
cd.querySelector('[data-s]').textContent=p(s%60);
}
tick();setInterval(tick,1000);
}

/* ---------------- recensioni: drawer "tutte" ---------------- */
var more=document.querySelector('[data-ws-more]');
if(more)more.addEventListener('click',function(){
var d=$('rev-drawer');
if(!d){
d=document.createElement('div');
d.className='rev-drawer';d.id='rev-drawer';
d.innerHTML='<div class="rd-bg" data-close></div><div class="rd-panel" role="dialog" aria-modal="true" aria-label="Tutte le recensioni"><div class="rd-head"><h3>Recensioni verificate</h3><button class="rd-close" type="button" data-close aria-label="Chiudi">✕</button></div><div class="rd-list"></div></div>';
document.body.appendChild(d);
d.addEventListener('click',function(e){if(e.target.hasAttribute('data-close'))d.classList.remove('is-on')});
}
var list=d.querySelector('.rd-list');
list.innerHTML='';
document.querySelectorAll('.ws-reviews__list .rev').forEach(function(r){list.appendChild(r.cloneNode(true))});
d.classList.add('is-on');
});
document.addEventListener('keydown',function(e){
if(e.key!=='Escape')return;var d=$('rev-drawer');if(d)d.classList.remove('is-on');
});

/* ---------------- avvio + osservatori app ---------------- */
function boot(){
placeAppBlocks();
captureUploadLift();
syncUploadUI();
bindOptions();
applyVariant();
mirrorProps();
paint();
drawFiles();
}
window.WSPDP={bindOptions:bindOptions,paint:paint,money:money,data:data,applyVariant:(typeof applyVariant==='function'?applyVariant:null)};
/* alcuni script del tema riscrivono type="submit" sui bottoni dentro il form
   prodotto: l'unico submit ammesso è la CTA allo step 4 */
function lockButtons(){
form.querySelectorAll('button').forEach(function(b){
if(b===btnGo)return;
if(b.type!=='button'){b.type='button';b.removeAttribute('name')}
});
if(cur<4&&!piatto()&&btnGo.type!=='button'){btnGo.type='button';btnGo.removeAttribute('name')}
}
lockButtons();

/* Alcuni script del tema agganciano l'add-to-cart DIRETTAMENTE sui bottoni del
   form: l'unico modo sicuro è sostituirli con un clone (che perde ogni listener
   esterno) e gestire i click per delega. */
function stripListeners(){
form.querySelectorAll('button').forEach(function(b){
if(b===btnGo||b.dataset.wsClean)return;
var c=b.cloneNode(true);
c.dataset.wsClean='1';
c.type='button';
c.removeAttribute('name');
b.parentNode.replaceChild(c,b);
});
}
window.WSPDP_proofCents=function(){
if(proof!=='yes'||!data.proof)return 0;
if(typeof data.proof.price==='number')return data.proof.price;
var m=String(data.proof.price_f||'').replace(/\s/g,'').match(/([\d.]+)[,.](\d{2})/);
return m?Math.round(parseFloat(m[1].replace(/\./g,''))*100)+ +m[2]:0;
};
/* la CTA può essere stata riportata a type="button" dal guardiano:
   la ripristino prima di inviare, altrimenti requestSubmit la rifiuta */
/* Shopify unisce le righe identiche: con una proprietà nascosta diversa a
   ogni invio (il prefisso _ la tiene fuori dal carrello e dall'ordine)
   ogni kit configurato resta una riga a sé, anche se uguale a una precedente. */
function rigaDistinta(){
var n=form.querySelector('input[name="properties[_kit]"]');
if(!n){
n=document.createElement('input');
n.type='hidden';
n.name='properties[_kit]';
form.appendChild(n);
}
n.value=Date.now().toString(36)+Math.random().toString(36).slice(2,6);
}
function submitKit(){
try{
rigaDistinta();
/* con l'invio nativo Shopify torna alla pagina prodotto: return_to porta
   direttamente al carrello, senza aspettare il nostro rimando */
var rt=form.querySelector('input[name="return_to"]');
if(!rt){
rt=document.createElement('input');
rt.type='hidden';
rt.name='return_to';
form.appendChild(rt);
}
rt.value='/cart';
btnGo=$('btn-go')||btnGo;
btnGo.disabled=false;
btnGo.type='submit';
btnGo.setAttribute('name','add');
/* dopo l'aggiunta si va sempre alla pagina carrello, mai al drawer */
btnGo.innerHTML='Aggiunta in corso…';
clearTimeout(submitKit.t);
submitKit.t=setTimeout(function(){location.href='/cart'},2600);
if(form.requestSubmit)form.requestSubmit(btnGo);else form.submit();
}catch(err){
console.warn('[wow-pdp] requestSubmit fallito, uso submit():',err);
try{form.submit()}catch(err2){console.error('[wow-pdp] invio fallito:',err2);inviando=false;btnGo.disabled=false}
}
}
var proofAdded=false;
var inviando=false;
function bloccaInvio(){
inviando=true;
clearTimeout(bloccaInvio.t);
/* se l'invio non porta a nulla (errore di rete, app lenta) si riparte */
bloccaInvio.t=setTimeout(function(){inviando=false;proofAdded=false;if(btnGo)btnGo.disabled=false},6000);
}
/* messaggio accanto alla CTA in fondo alle card (mobile) */
function avvisoCta(txt){
var mirror=form.querySelector('.bar-inline');
if(!mirror)return;
var n=form.querySelector('.ws-go-err');
if(!txt){if(n)n.hidden=true;return}
if(!n){
n=document.createElement('p');
n.className='ws-go-err';
n.setAttribute('role','status');
mirror.parentNode.insertBefore(n,mirror);
}
n.textContent=txt;
n.hidden=false;
}
form.addEventListener('click',function(e){
var b=e.target.closest('button');
if(!b||!form.contains(b))return;
if(b===btnGo||b.id==='btn-go'){
btnGo=b;
if(inviando){e.preventDefault();e.stopImmediatePropagation();return}
if(b.disabled){e.preventDefault();e.stopImmediatePropagation();b.disabled=false;return}
if(piatto()){
/* un unico controllo su tutte le card, poi l'invio */
var bloccato=0;
for(var s=1;s<=3;s++){if(!valid(s)){bloccato=s;break}}
if(bloccato){
e.preventDefault();e.stopImmediatePropagation();
var el=$('err-'+bloccato);
if(el)el.classList.add('is-on');
avvisoCta(el?el.textContent:'Completa i campi mancanti prima di aggiungere al carrello.');
var pan=form.querySelector('.panel[data-step="'+bloccato+'"]');
if(pan){var y=pan.getBoundingClientRect().top+window.pageYOffset-70;window.scrollTo({top:y,behavior:'smooth'})}
return;
}
avvisoCta('');
bloccaInvio();
/* invio esplicito: non dipendiamo dall'azione predefinita del click */
if(!(proof==='yes'&&data.proof&&data.proof.id&&!proofAdded&&!form.querySelector('[data-proof-fixed]'))){
e.preventDefault();e.stopImmediatePropagation();
submitKit();
return;
}
}
console.log('[wow-pdp] CTA click · step',cur,'· anteprima',proof,'· variante',($('ws-variant-id')||{}).value);
if(cur<4){
e.preventDefault();e.stopPropagation();
if(!valid(cur)){var el=$('err-'+cur);if(el)el.classList.add('is-on');return}
show(cur+1);
return;
}
/* step 4 con anteprima a pagamento: aggiungo kit e servizio in due righe
   di carrello, come fa la scheda anteprima delle altre pagine prodotto */
if(proof==='yes'&&data.proof&&data.proof.id&&!proofAdded&&!form.querySelector('[data-proof-fixed]')){
e.preventDefault();e.stopImmediatePropagation();
proofAdded=true;
btnGo.disabled=true;
var endpoint='/cart/add.js';
try{var u=new URL(form.getAttribute('action')||'/cart/add',location.origin);u.pathname='/cart/add.js';u.search='';endpoint=u.toString()}catch(err){}
function proofError(msg){
console.error('[wow-pdp] anteprima di stampa:',msg);
var note=form.querySelector('.bar-note');
if(note){note.textContent='Anteprima di stampa non aggiunta: '+msg;note.style.color='#E14B26'}
}
/* tre tentativi: items JSON, form-urlencoded classico, variante dall'handle */
function postJSON(vid){
return fetch(endpoint,{
method:'POST',credentials:'same-origin',
headers:{'Content-Type':'application/json',Accept:'application/json'},
body:JSON.stringify({items:[{id:vid,quantity:1,properties:{prodotto:((document.querySelector('.p-title')||{}).textContent||document.title).trim()}}]})
});
}
function postForm(vid){
var b=new URLSearchParams();
b.append('id',vid);b.append('quantity','1');
return fetch(endpoint,{
method:'POST',credentials:'same-origin',
headers:{'Content-Type':'application/x-www-form-urlencoded',Accept:'application/json'},
body:b.toString()
});
}
function fromHandle(){
if(!data.proof.handle)return Promise.reject(new Error('handle mancante'));
return fetch('/products/'+data.proof.handle+'.js',{credentials:'same-origin'})
.then(function(r){if(!r.ok)throw new Error('prodotto anteprima non trovato ('+r.status+')');return r.json()})
.then(function(prod){
var v=(prod.variants||[]).filter(function(x){return x.available})[0]||(prod.variants||[])[0];
if(!v)throw new Error('nessuna variante disponibile');
return postJSON(v.id);
});
}
function addProof(vid){
return postJSON(vid)
.then(function(r){
if(r.ok)return true;
return r.text().then(function(t1){
console.warn('[wow-pdp] items JSON fallito:',r.status,t1);
return postForm(vid).then(function(r2){
if(r2.ok)return true;
return r2.text().then(function(t2){
console.warn('[wow-pdp] form-urlencoded fallito:',r2.status,t2);
return fromHandle().then(function(r3){
if(r3&&r3.ok)return true;
return (r3?r3.text():Promise.resolve('')).then(function(t3){
throw new Error((t3||t2||t1||'errore sconosciuto').slice(0,200));
});
});
});
});
});
});
}
/* Il kit NON va aggiunto via fetch: VOPO applica il sovrapprezzo agganciandosi
   al submit del form (e il tema aggiunge le sue proprietà). Aggiungiamo prima
   il servizio anteprima, poi lasciamo fare il submit vero. */
addProof(data.proof.id)
.then(function(){
btnGo.disabled=false;
submitKit();
})
.catch(function(err){
proofError((err&&err.message)||err);
btnGo.disabled=false;
setTimeout(submitKit,2000);
});
return;
}
if(proof==='yes'&&!data.proof)console.warn('[wow-pdp] Anteprima di stampa: prodotto non configurato nel theme editor');
return;
}
if(b.hasAttribute('data-proof')){
e.preventDefault();e.stopPropagation();
form.querySelectorAll('[data-proof]').forEach(function(o){o.setAttribute('aria-pressed','false')});
b.setAttribute('aria-pressed','true');
proof=b.dataset.proof;
var pn=$('proof-note');if(pn)pn.classList.toggle('is-on',proof==='yes');
paint();hideErr();
if(window.WSPDP_totals)WSPDP_totals();else applyVariant();
return;
}
if(b.classList.contains('back-step')){
e.preventDefault();e.stopPropagation();
if(cur>1)show(cur-1);
}
},true);
stripListeners();
window.addEventListener('load',function(){stripListeners();lockButtons()});
setTimeout(function(){stripListeners();lockButtons()},2000);
window.WSPDP_strip=stripListeners;

new MutationObserver(lockButtons).observe(form,{subtree:true,attributes:true,attributeFilter:['type'],childList:true});
window.WSPDP_lock=lockButtons;

show(1,true);
if(PIATTO.addEventListener)PIATTO.addEventListener('change',function(){show(piatto()?4:1,true)});
boot();
var pending=null;
new MutationObserver(function(recs){
var relevant=recs.some(function(r){
return [].some.call(r.addedNodes,function(n){
return n.nodeType===1&&(n.matches('.shopify-app-block,.cl-upload--wrapper,.filepond--root,.selector-wrapper')||n.querySelector&&n.querySelector('.cl-upload--wrapper,.filepond--root,.selector-wrapper,.shopify-app-block'));
});
});
if(!relevant)return;
clearTimeout(pending);
pending=setTimeout(boot,120);
}).observe(document.body,{childList:true,subtree:true});

/* Shopify: sezione ricaricata nel theme editor */
document.addEventListener('shopify:section:load',function(e){
if(e.target.querySelector('#ws-form'))location.reload();
});
})();

/* comportamenti solo mobile: accordion configuratore, caroselli, FAQ ridotte */
(function(){
var MQ=window.matchMedia('(max-width:899px)');
var ready=false;

function carousel(scroller){
  if(!scroller||scroller.dataset.mwCar)return;
  var items=[].slice.call(scroller.children);
  if(items.length<2)return;
  scroller.dataset.mwCar='1';
  var dots=document.createElement('div');
  dots.className='mw-dots';
  items.forEach(function(it,i){
    var b=document.createElement('button');
    b.type='button';
    b.setAttribute('aria-label','Vai alla scheda '+(i+1));
    b.setAttribute('aria-pressed',i===0?'true':'false');
    b.addEventListener('click',function(){
      scroller.scrollTo({left:it.offsetLeft-scroller.offsetLeft,behavior:'smooth'});
    });
    dots.appendChild(b);
  });
  scroller.parentNode.insertBefore(dots,scroller.nextSibling);
  var t;
  scroller.addEventListener('scroll',function(){
    clearTimeout(t);
    t=setTimeout(function(){
      var mid=scroller.scrollLeft+scroller.clientWidth/2,best=0,bd=1e9;
      items.forEach(function(it,i){
        var c=it.offsetLeft-scroller.offsetLeft+it.offsetWidth/2,d=Math.abs(c-mid);
        if(d<bd){bd=d;best=i}
      });
      [].slice.call(dots.children).forEach(function(b,i){b.setAttribute('aria-pressed',String(i===best))});
    },70);
  },{passive:true});
}

/* Su mobile il configuratore è intero: i gruppi restano tutti aperti, senza
   fisarmonica né freccette. */
function accordion(){
  var slot=document.getElementById('ws-bcpo-slot');
  if(!slot)return;
  slot.querySelectorAll('.selector-wrapper').forEach(function(w){
    w.classList.add('mw-open');
    var lab=w.querySelector('.bcpo-label');
    if(!lab)return;
    lab.removeAttribute('role');
    lab.removeAttribute('tabindex');
    lab.removeAttribute('aria-expanded');
  });
}

function faq(){
  var box=document.querySelector('#faq .faq');
  if(!box||box.dataset.mwFaq)return;
  var ds=[].slice.call(box.querySelectorAll('details'));
  if(ds.length<=4)return;
  box.dataset.mwFaq='1';
  ds.slice(4).forEach(function(d){d.classList.add('mw-hide')});
  var b=document.createElement('button');
  b.type='button';
  b.className='mw-faq-all';
  b.innerHTML='Vedi tutte le FAQ <span aria-hidden="true">→</span>';
  b.addEventListener('click',function(){
    ds.forEach(function(d){d.classList.remove('mw-hide')});
    b.remove();
  });
  box.parentNode.appendChild(b);
}

function init(){
  if(!MQ.matches)return;
  accordion();
  if(ready)return;
  ready=true;
  faq();
  carousel(document.querySelector('.app-grid'));
  carousel(document.querySelector('.ws-reviews__list'));
}

setTimeout(init,150);
if(MQ.addEventListener)MQ.addEventListener('change',init);
})();

/* ---------------- ibrido: varianti native + VOPO ----------------
   "Dimensione Roll-Up" è un'opzione Shopify (prezzo dalla variante).
   "Lavorazioni e Rifiniture Banner" resta gestita da VOPO: il suo blocco viene
   portato nello slot, skinnato con i nostri pulsanti e il sovrapprezzo si somma
   al prezzo di variante. L'add-to-cart resta il submit nativo del form, che è
   il momento in cui VOPO applica l'addon. */
(function(){
var slot=document.getElementById('ws-bcpo-slot');if(!slot)return;
var obs=null,busy=false,queued=false;

function app(){return document.getElementById('bcpo')||document.querySelector('.bcpo')}

function titoloDi(w){
var t=w.querySelector('.bcpo-title');
var s=t?t.textContent:'';
if(!s){var sel=w.querySelector('select');s=sel?(sel.getAttribute('aria-label')||sel.name||''):''}
return s.replace(/:\s*$/,'').replace(/^options?\[|\]$/g,'').toLowerCase().trim();
}
function nativo(w){return !!w.querySelector('select[name^="options["]')}
/* un solo gruppo per titolo: vince sempre la variante Shopify */
function dedup(){
var visti={},tolti=0;
[].slice.call(slot.querySelectorAll('.selector-wrapper')).sort(function(a,b){
return (nativo(b)?1:0)-(nativo(a)?1:0);
}).forEach(function(w){
var k=titoloDi(w);
if(!k)return;
if(visti[k]&&visti[k]!==w){w.remove();tolti++;return}
visti[k]=w;
});
if(tolti)console.log('[wow-pdp] gruppi opzione duplicati rimossi:',tolti);
return tolti;
}

function needsWork(){
if(dedup())return true;
var a=app();if(!a)return false;
if(!slot.contains(a))return true;
return [].slice.call(slot.querySelectorAll('.bcpo .selector-wrapper')).some(function(w){
var sels=[].slice.call(w.querySelectorAll('select')).filter(function(s){
return !s.classList.contains('ws-dd__sel');
});
if(!sels.length)return false;
if(isPrintPosition(w))return sels.some(function(s){return s.hidden||s.style.display==='none'});
if(!w.querySelector('.opt'))return true;
return sels.some(function(s){return s.style.display!=='none'});
});
}

function apply(){
if(busy)return;
busy=true;
if(obs)obs.disconnect();
try{
var a=app();
if(a){
if(!slot.contains(a))slot.appendChild(a);
/* le opzioni Shopify native vanno per prime, sopra il blocco dell'app */
[].slice.call(slot.querySelectorAll('.selector-wrapper')).filter(function(w){
return !a.contains(w)&&w.querySelector('select[name^="options["]');
}).reverse().forEach(function(w){slot.insertBefore(w,slot.firstChild)});
document.querySelectorAll('.bcpo,#bcpo').forEach(function(o){if(o!==a&&!slot.contains(o))o.remove()});
var ad=a.querySelector('.bcpo-price-addons');if(ad)ad.style.display='none';
var mirror=a.querySelector('#bcpo-select');if(mirror)mirror.style.display='none';
/* le opzioni VOPO che duplicano un'opzione Shopify non servono */
dedup();
a.querySelectorAll('.selector-wrapper').forEach(function(w){
if(!w.querySelector('.opt')){w.removeAttribute('data-ws-bound');delete w.dataset.wsBound}
});
if(window.WSPDP&&WSPDP.bindOptions){WSPDP.bindOptions(a);WSPDP.bindOptions(slot)}
a.querySelectorAll('select').forEach(function(s){
if(s.classList.contains('ws-dd__sel'))return;
if(isPrintPosition(s.closest('.selector-wrapper'))){restoreNativeSelect(s.closest('.selector-wrapper'),s);return}
s.hidden=true;
s.style.setProperty('display','none','important');
s.setAttribute('aria-hidden','true');
s.tabIndex=-1;
});
if(window.WSPDP&&WSPDP.paint)WSPDP.paint();
if(window.WSPDP_lock)WSPDP_lock();
if(window.WSPDP_strip)WSPDP_strip();
totals();
}
/* rete di sicurezza: se lo slot è rimasto senza pulsanti, ricostruisco */
if(!slot.querySelector('.opt')&&window.WSPDP&&WSPDP.bindOptions){
console.warn('[wow-pdp] slot opzioni vuoto: ricostruisco');
WSPDP.bindOptions(slot);
}
}catch(e){console.error('[wow-pdp] ponte opzioni:',e)}
busy=false;
if(obs)obs.observe(document.body,{childList:true,subtree:true});
}

function cents(txt){
var m=(txt||'').replace(/\s/g,'').match(/([\d.]+)[,.](\d{2})/);
if(!m)return 0;
return Math.round(parseFloat(m[1].replace(/\./g,''))*100)+ +m[2];
}
/* prezzo di variante + eventuale addon VOPO */
function totals(){
if(!window.WSPDP||!WSPDP.data)return;
var f=document.getElementById('ws-variant-id');
var v=(WSPDP.data.variants||[]).filter(function(x){return String(x.id)===String(f&&f.value)})[0]||WSPDP.data.variants[0];
if(!v)return;
var el=document.querySelector('.bcpo-addons-price');
/* con l'anteprima di stampa scelta, il suo prezzo entra nel totale */
var extra=(window.WSPDP_proofCents&&WSPDP_proofCents())||0;
var txt=WSPDP.money(v.price+(el?cents(el.textContent):0)+extra);
['bar-tot','hero-now','sum-tot'].forEach(function(id){
var n=document.getElementById(id);
if(n&&n.textContent!==txt)n.textContent=txt;
});
}
window.WSPDP_totals=totals;

function soon(){[0,80,200,450,900,1500].forEach(function(ms){setTimeout(totals,ms)})}
slot.addEventListener('click',function(e){if(e.target.closest('.opt'))soon()});
slot.addEventListener('change',soon,true);
function watchPrice(){
var el=document.querySelector('.bcpo-addons-price');
if(!el||el.dataset.wsWatched)return;
el.dataset.wsWatched='1';
new MutationObserver(totals).observe(el,{childList:true,characterData:true,subtree:true});
totals();
}
watchPrice();
WSPDP_pass(watchPrice);

apply();
var tries=0,t=setInterval(function(){if(needsWork())apply();if(++tries>40)clearInterval(t)},400);
obs=new MutationObserver(function(){
dedup();
if(queued)return;
queued=true;
setTimeout(function(){queued=false;if(needsWork())apply()},120);
});
obs.observe(document.body,{childList:true,subtree:true});
})();

/* ---------------- recensioni: app WOWstampa Reviews ----------------
   GET <endpoint>/api/reviews?shop=&productId=&productHandle=&limit=
   payload: {average,total,distribution:[{rating,count,percent}],reviews:[…]} */
(function(){
var sec=document.querySelector('[data-ws-reviews]');if(!sec)return;
var list=sec.querySelector('[data-ws-list]');if(!list)return;
var base=(sec.dataset.endpoint||'').trim().replace(/\/+$/,'');
if(!base){list.innerHTML='<p class="rv-empty">Recensioni non configurate.</p>';return}
if(!/\/api\/reviews$/.test(base))base+='/api/reviews';
var url=base+'?shop='+encodeURIComponent(sec.dataset.shop||'')
+'&productId='+encodeURIComponent(sec.dataset.productId||'')
+'&productHandle='+encodeURIComponent(sec.dataset.productHandle||'')
+'&limit='+(parseInt(sec.dataset.limit,10)||6);
var all=[],filtro=0;
function stars(n){n=Math.round(n||0);return '★★★★★'.slice(0,n)+'☆☆☆☆☆'.slice(0,5-n)}
function data(s){
var d=new Date(s);
if(isNaN(d))return '';
return d.toLocaleDateString('it-IT',{day:'numeric',month:'long'});
}
function etichetta(m){
if(m>=4.7)return 'Eccellente';
if(m>=4)return 'Molto buono';
if(m>=3)return 'Medio';
if(m>=2)return 'Scarso';
return 'Pessimo';
}
function card(r){
var a=document.createElement('article');
a.className='rev';
var iniziale=(r.authorName||'?').trim().charAt(0).toUpperCase();
var meta=[r.authorType,data(r.reviewDate)].filter(Boolean).join(' · ');
var top=document.createElement('div');
top.className='rev-top';
top.innerHTML='<span class="rev-av"></span><div><div class="rev-who"></div><div class="rev-meta"></div></div><span class="stars" aria-hidden="true"></span>';
top.querySelector('.rev-av').textContent=iniziale;
top.querySelector('.rev-who').textContent=r.authorName||'Cliente';
top.querySelector('.rev-meta').textContent=meta;
top.querySelector('.stars').textContent=stars(r.rating);
a.appendChild(top);
var p=document.createElement('p');
p.textContent='“'+(r.body||r.title||'').trim()+'”';
a.appendChild(p);
if(r.photoUrl){
var img=document.createElement('img');
img.src=r.photoUrl;img.alt='';img.loading='lazy';img.className='rev-photo';
a.appendChild(img);
}
var foot=document.createElement('div');
foot.className='rev-foot';
if(r.tag){var t=document.createElement('span');t.className='rev-tag';t.textContent=r.tag;foot.appendChild(t)}
if(r.verified!==false){var v=document.createElement('span');v.className='rev-ok';v.textContent='✓ Acquisto verificato';foot.appendChild(v)}
if(foot.children.length)a.appendChild(foot);
return a;
}
function render(){
var vis=filtro?all.filter(function(r){return Math.round(r.rating)===filtro}):all;
list.innerHTML='';
if(!vis.length){
var p=document.createElement('p');
p.className='rv-empty';
p.textContent=filtro?'Nessuna recensione con questo punteggio.':'Ancora nessuna recensione per questo prodotto.';
list.appendChild(p);
return;
}
vis.forEach(function(r){list.appendChild(card(r))});
}
function riepilogo(d){
var media=d.average||0,tot=d.total||all.length;
var av=sec.querySelector('[data-ws-average]');if(av)av.textContent=(Math.round(media*10)/10).toString().replace('.',',');
sec.querySelectorAll('[data-ws-total]').forEach(function(n){n.textContent=tot});
var lab=sec.querySelector('[data-ws-rating-label]');if(lab)lab.textContent=etichetta(media);
var top=sec.querySelector('.rv-score .stars');if(top)top.textContent=stars(media);
var dist={};(d.distribution||[]).forEach(function(x){dist[x.rating]={count:x.count,percent:x.percent}});
sec.querySelectorAll('[data-ws-rating-filter]').forEach(function(b){
var s=+b.dataset.wsRatingFilter,x=dist[s]||{count:0,percent:0};
var bar=b.querySelector('i>b');if(bar)bar.style.width=(x.percent||0)+'%';
var num=b.querySelector('em');if(num)num.textContent=x.count||0;
if(!b.dataset.wsBound){
b.dataset.wsBound='1';
b.addEventListener('click',function(e){
e.preventDefault();
filtro=filtro===s?0:s;
sec.querySelectorAll('[data-ws-rating-filter]').forEach(function(o){
o.setAttribute('aria-pressed',String(+o.dataset.wsRatingFilter===filtro));
});
render();
});
}
});
}
var quante=parseInt(sec.dataset.limit,10)||6;
console.log('[wow-pdp] recensioni · richiesta:',url);
/* l'app su Render può essere in cold start: un secondo tentativo dopo 4s */
function carica(tentativo){
return fetch(url,{credentials:'omit',mode:'cors'})
.then(function(r){
return r.text().then(function(txt){
if(!r.ok)throw new Error('HTTP '+r.status+' · '+txt.slice(0,200));
try{return JSON.parse(txt)}catch(e){throw new Error('risposta non JSON · '+txt.slice(0,200))}
});
})
.then(function(d){
console.log('[wow-pdp] recensioni · risposta:',d);
if(d.error)console.warn('[wow-pdp] recensioni · errore API:',d.error);
all=(d.reviews||[]).slice(0,quante);
riepilogo(d);
if(!all.length){
list.innerHTML='<p class="rv-empty">Ancora nessuna recensione per questo prodotto.</p>';
return;
}
render();
})
.catch(function(err){
console.error('[wow-pdp] recensioni · tentativo '+tentativo+':',err);
if(tentativo<2){
list.innerHTML='<p class="rv-empty">Caricamento recensioni…</p>';
return new Promise(function(ok){setTimeout(function(){ok(carica(tentativo+1))},4000)});
}
list.innerHTML='<p class="rv-empty">Recensioni non disponibili al momento.</p>';
});
}
carica(1);
})();

/* ---- mobile: copia fissa della barra prezzo dentro il configuratore ---- */
(function(){
var MQ=window.matchMedia('(max-width:899px)');
var form=document.getElementById('ws-form')||document.querySelector('form.wz');
if(!form)return;
var bar=form.querySelector('.bar');if(!bar)return;
var mirror=document.createElement('div');
mirror.className='bar-inline';
/* niente clone del pulsante: su mobile spostiamo qui il vero #btn-go, così
   si comporta esattamente come su desktop (stessi handler, stesso submit) */
mirror.innerHTML='<div class="bar-p"><span class="lab"></span><span class="v"></span><span class="u"></span></div>';
bar.parentNode.insertBefore(mirror,bar);
function go(){return document.getElementById('btn-go')}
var azioni=bar.querySelector('.bar-actions');
function sposta(){
var g=go();if(!g)return;
if(MQ.matches){
if(g.parentNode!==mirror)mirror.appendChild(g);
}else if(azioni&&g.parentNode!==azioni){
azioni.appendChild(g);
}
}
function sync(){
sposta();
if(!MQ.matches)return;
var lab=document.getElementById('bar-lab'),tot=document.getElementById('bar-tot'),unit=document.getElementById('bar-unit');
var bp=bar.querySelector('.bar-p');
var mp=mirror.querySelector('.bar-p');
if(!mp)return;
mirror.querySelector('.lab').textContent=lab?lab.textContent:'';
mirror.querySelector('.v').textContent=tot?tot.textContent:'';
mirror.querySelector('.u').textContent=unit?unit.textContent:'';
mp.hidden=!!(bp&&bp.hidden);
mirror.classList.toggle('bar-inline--final',bar.classList.contains('bar--final'));
}
new MutationObserver(sync).observe(bar,{subtree:true,childList:true,characterData:true,attributes:true});
if(MQ.addEventListener)MQ.addEventListener('change',sync);
sync();
WSPDP_pass(sync);
})();

/* ---------------- upload condizionati alla posizione di stampa ----------------
   L'opzione "Posizione Stampa" (o simile) dichiara quali lati vengono stampati:
   mostriamo solo i box Upload Lift che corrispondono, riconosciuti dalla loro
   etichetta ("File Lato Cuore", "File Retro"…) o dal Form field name.
   I box non pertinenti vengono nascosti e i loro file rimossi, così al carrello
   non arrivano grafiche di lati non ordinati. */
(function(){
var slot=document.getElementById('ws-upload-slot');if(!slot)return;

/* lati riconosciuti: chiave -> parole che possono comparire nell'etichetta */
var LATI=[
['lato cuore',['lato cuore','cuore','left chest','petto']],
['fronte',['fronte','front','davanti']],
['retro',['retro','back','dietro','schiena']],
['manica destra',['manica destra','right sleeve']],
['manica sinistra',['manica sinistra','left sleeve']]
];
function norm(s){return (s||'').toLowerCase().replace(/\s+/g,' ').trim()}

function selPosizione(){
var w=document.querySelector('[data-vopo="posizione-stampa"]')||
      [].slice.call(document.querySelectorAll('.selector-wrapper')).filter(function(x){
        var t=x.querySelector('.bcpo-title');
        return t&&/posizion|stampa su|lati di stampa/i.test(t.textContent);
      })[0];
return w?w.querySelector('select'):null;
}

/* dalla scelta ricavo i lati richiesti: "Fronte + Retro" -> fronte, retro */
function latiRichiesti(){
var s=selPosizione();
if(!s)return null;
var v=norm(s.value);
if(!v)return null;
var out=[];
v.split(/\+|,|\/|\be\b/).forEach(function(part){
var p=norm(part);
if(!p)return;
LATI.forEach(function(l){
if(out.indexOf(l[0])>=0)return;
if(l[1].some(function(k){return p.indexOf(k)>=0}))out.push(l[0]);
});
});
return out.length?out:null;
}

function etichetta(box){
var lab=box.querySelector('.filepond--drop-label label,.cl-upload--label,label');
var txt=lab?lab.textContent:'';
var inp=box.querySelector('input[type=file]');
if(inp)txt+=' '+(inp.getAttribute('name')||'')+' '+(inp.getAttribute('data-field')||'');
return norm(txt);
}
/* a quale lato appartiene il box; null = non riconosciuto, resta visibile */
function latoDi(box){
var t=etichetta(box);
var best=null;
LATI.forEach(function(l){
l[1].forEach(function(k){
if(t.indexOf(k)<0)return;
if(!best||k.length>best.k)best={lato:l[0],k:k.length};
});
});
return best?best.lato:null;
}

function svuota(box){
box.querySelectorAll('.filepond--file-action-button[data-align],.filepond--action-remove-item').forEach(function(b){
try{b.click()}catch(e){}
});
}

function apply(){
var richiesti=latiRichiesti();
var boxes=[].slice.call(slot.querySelectorAll('.cl-upload--wrapper,.up-field'));
if(!boxes.length)return;
boxes.forEach(function(box){
if(box.querySelector('.cl-upload--wrapper'))return; /* contenitore esterno */
var lato=latoDi(box);
var mostra=!richiesti||!lato||richiesti.indexOf(lato)>=0;
var wrap=box.closest('.up-field')||box;
if(wrap.hidden===!mostra)return;
wrap.hidden=!mostra;
wrap.setAttribute('aria-hidden',String(!mostra));
if(!mostra)svuota(box);
});
if(window.WSPDP&&WSPDP.paint)WSPDP.paint();
}

var soon=WSPDP_pass(apply);
document.addEventListener('change',function(e){
if(e.target&&e.target.tagName==='SELECT')soon();
},true);
document.addEventListener('click',function(e){
if(e.target.closest&&e.target.closest('.opt'))soon();
},true);
window.WSPDP_uploadSides=apply;
})();

/* ---------------- swatch colore: solo la prima riga + "Mostra tutti" ----------------
   VOPO stampa tutte le pastiglie una dopo l'altra: su liste lunghe lo step 1
   diventa altissimo. Calcoliamo quante entrano in una riga e nascondiamo il
   resto dietro un pulsante che diventa "Chiudi". */
(function(){
var slot=document.getElementById('ws-bcpo-slot');if(!slot)return;

function gruppiColore(){
return [].slice.call(document.querySelectorAll('.selector-wrapper')).filter(function(w){
if(w.querySelector('.bcpo-images,.bcpo-front-image-option'))return true;
var t=w.querySelector('.bcpo-title');
return t&&/colore|colour|color/i.test(t.textContent);
});
}

function applica(w){
var box=w.querySelector('.single-option-selector')||w.querySelector('.bcpo-images')||w;
var items=[].slice.call(box.querySelectorAll('.bcpo-image-parent'));
if(items.length<2)return;

/* prima riga: gli elementi che condividono la coordinata verticale del primo */
items.forEach(function(it){it.classList.remove('ws-sw-hide')});
var aperto=w.classList.contains('ws-sw-open');
var top=items[0].getBoundingClientRect().top;
var perRiga=items.filter(function(it){return Math.abs(it.getBoundingClientRect().top-top)<4}).length;
if(!perRiga||perRiga>=items.length){
var b0=w.querySelector('.ws-sw-more');if(b0)b0.remove();
return;
}
/* la pastiglia selezionata resta sempre in vista */
var selIdx=items.findIndex(function(it){var i=it.querySelector('input');return i&&i.checked});
var visibili=perRiga;
if(selIdx>=visibili)visibili=perRiga; /* niente scorrimento: la mostriamo aperta */
if(!aperto&&selIdx>=perRiga)w.classList.add('ws-sw-open'),aperto=true;

if(!aperto)items.slice(visibili).forEach(function(it){it.classList.add('ws-sw-hide')});

var b=w.querySelector('.ws-sw-more');
if(!b){
b=document.createElement('button');
b.type='button';
b.className='ws-sw-more';
b.setAttribute('data-ws-clean','1');
b.addEventListener('click',function(e){
e.preventDefault();e.stopPropagation();
w.classList.toggle('ws-sw-open');
applica(w);
});
box.parentNode.insertBefore(b,box.nextSibling);
}
var nascosti=items.length-visibili;
var testo=aperto?'Chiudi':'Mostra tutti i colori ('+items.length+')';
if(b.textContent!==testo)b.textContent=testo;
if(b.getAttribute('aria-expanded')!==String(aperto))b.setAttribute('aria-expanded',String(aperto));
var nascondi=nascosti<=0&&!aperto;
if(b.hidden!==nascondi)b.hidden=nascondi;
}

function tutti(){gruppiColore().forEach(applica)}
var soon=WSPDP_pass(tutti);
document.addEventListener('change',function(e){
if(e.target&&e.target.name&&/colore/i.test(e.target.name)){soon();if(window.WSPDP&&WSPDP.paint)WSPDP.paint()}
},true);
window.WSPDP_swatches=tutti;
})();

/* ---------------- taglie: riepilogo e tetto per pacchetto ----------------
   Il riepilogo va accanto all'etichetta ("S: 5 · M: 3") perché il gruppo usa
   campi quantità e VOPO non compila .bcpo-value.
   Il tetto arriva dal metafield prodotto custom.pack_limits, scritto come
   "chiave:numero" (es. "taglie-t-shirt:25", più coppie separate da virgola o
   riga nuova): la somma delle quantità non può superare quel numero. */
(function(){
var limiti=null;
/* la sorgente può essere: lo script stampato dal Liquid, un attributo sul
   gruppo, un meta o una variabile globale — proviamo tutte */
function sorgente(){
var s=document.getElementById('ws-pack-limits');
if(s&&(s.textContent||'').trim())return s.textContent;
var el=document.querySelector('[data-pack-limits]');
if(el)return el.getAttribute('data-pack-limits')||el.textContent||'';
var m=document.querySelector('meta[name="ws-pack-limits"]');
if(m&&m.content)return m.content;
if(typeof window.wsPackLimits==='string')return window.wsPackLimits;
return '';
}
function leggiLimiti(){
if(limiti)return limiti;
limiti={};
var src=sorgente();
(src||'').split(/[,\n;]+/).forEach(function(riga){
var m=riga.split(':');
if(m.length<2)return;
var k=(m[0]||'').trim().toLowerCase();
var n=parseInt(m[1],10);
if(k&&n>0)limiti[k]=n;
});
return limiti;
}
function tetto(box){
/* limite dichiarato sul gruppo stesso */
var diretto=parseInt(box.getAttribute('data-pack-limit'),10);
if(diretto>0)return diretto;
var L=leggiLimiti();
var k=(box.getAttribute('data-pack-key')||'').trim().toLowerCase();
if(k&&L[k])return L[k];
var chiavi=Object.keys(L);
if(chiavi.length===1)return L[chiavi[0]];
if(k&&!box.dataset.wsWarned){
box.dataset.wsWarned='1';
console.warn('[wow-pdp] tetto taglie non trovato per "'+k+'". custom.pack_limits letto:',JSON.stringify(sorgente()),'· chiavi:',chiavi);
}
return 0;
}
function campi(box){return [].slice.call(box.querySelectorAll('.ws-size-qty'))}
function totale(box,escludi){
return campi(box).reduce(function(s,i){
if(i===escludi)return s;
return s+(parseInt(i.value,10)||0);
},0);
}
function riga(box){
var parti=[];
box.querySelectorAll('.ws-sizes__item').forEach(function(it){
var inp=it.querySelector('.ws-size-qty');
var n=parseInt(inp&&inp.value,10)||0;
if(n<=0)return;
var b=it.querySelector('.ws-sizes__badge');
parti.push(((b&&b.textContent)||'').trim()+': '+n);
});
return parti.join(' · ');
}
function messaggio(box,txt){
var err=box.querySelector('.ws-sizes__error');
if(!err)return;
if(txt){
if(err.textContent!==txt)err.textContent=txt;
err.hidden=false;
}else{
err.hidden=true;
if(err.textContent)err.textContent='';
}
}
/* contatore "18 / 25 pezzi" sotto i campi */
function contatore(box,somma,max){
if(!max)return;
var c=box.querySelector('.ws-sizes__count');
if(!c){
c=document.createElement('div');
c.className='ws-sizes__count';
var err=box.querySelector('.ws-sizes__error');
if(err)box.insertBefore(c,err);else box.appendChild(c);
}
var txt=somma+' / '+max+' pezzi';
if(c.textContent!==txt)c.textContent=txt;
c.classList.toggle('is-full',somma>=max);
}
function applica(box,attivo){
var max=tetto(box);
var somma=totale(box);
if(max){
/* le quantità scritte dal cliente non si toccano mai: segnaliamo soltanto
   quando il totale non corrisponde ai pezzi del kit */
campi(box).forEach(function(inp){inp.removeAttribute('max')});
if(somma>max){
messaggio(box,'Il kit è di '+max+' pezzi. Togline '+(somma-max)+'.');
}else{
messaggio(box,'');
}
contatore(box,somma,max);
}
var lab=(box.closest('.selector-wrapper')||box).querySelector('.bcpo-label label');
if(lab){
var v=lab.querySelector('.bcpo-value');
if(!v){
v=document.createElement('span');
v.className='bcpo-value';
v.setAttribute('data-ws-sizes-value','1');
lab.appendChild(v);
}
var txt=riga(box);
if(v.textContent!==txt)v.textContent=txt;
v.hidden=!txt;
}
var somm=box.querySelector('[data-ws-sizes-summary]');
if(somm){
var val=riga(box).replace(/ · /g,', ');
if(somm.value!==val)somm.value=val;
}
}
function tutti(){document.querySelectorAll('.ws-sizes').forEach(function(b){applica(b)})}
/* il kit ha un numero fisso di pezzi: finché non sono tutti assegnati lo step
   non è completo (il tetto impedisce già di superarlo) */
window.WSPDP_sizesState=function(){
var box=document.querySelector('.ws-sizes');
if(!box)return {ok:true,msg:''};
var max=tetto(box);
if(!max)return {ok:true,msg:''};
var somma=totale(box);
if(somma===max)return {ok:true,msg:''};
if(somma>max)return {ok:false,msg:'Il kit è di '+max+' pezzi. Togline '+(somma-max)+'.'};
var resto=max-somma;
return {ok:false,msg:'Il kit è di '+max+' pezzi. '+(resto===1?'Ne manca 1.':'Ne mancano '+resto+'.')};
};
function daCampo(e){
var inp=e.target;
if(!inp||!inp.classList||!inp.classList.contains('ws-size-qty'))return;
var box=inp.closest('.ws-sizes');
if(box)applica(box,true);
}
document.addEventListener('input',daCampo,true);
document.addEventListener('change',daCampo,true);
WSPDP_pass(tutti);
window.WSPDP_sizesLabel=tutti;
document.addEventListener('input',function(e){
if(e.target&&e.target.classList&&e.target.classList.contains('ws-size-qty')&&window.WSPDP&&WSPDP.paint)WSPDP.paint();
},true);
})();

/* ---------------- "Posizione Stampa": dropdown VOPO originale ---------------- */
(function(){
function titoloPos(w){
var t=w.querySelector('.bcpo-title');
return t&&/posizion[ei] stampa|lati di stampa|stampa su/i.test(t.textContent);
}
function gruppiPos(){
var out=[];
var nat=document.querySelector('[data-vopo="posizione-stampa"]');
if(nat)out.push(nat);
[].slice.call(document.querySelectorAll('.selector-wrapper')).forEach(function(w){
if(out.indexOf(w)<0&&titoloPos(w))out.push(w);
});
return out;
}
/* L'opzione è UNA sola (quella nativa Shopify) ma viene disegnata due volte:
   dal nostro Liquid e da VOPO, che la reimporta. Ne mostriamo una e teniamo
   allineate tutte le select coinvolte, così l'app continua a calcolare la
   variante e il prezzo. */
function gruppo(){
var g=gruppiPos();
if(!g.length)return null;
var nativo=g.filter(function(w){return w.querySelector('select[name^="options["]')})[0];
var scelto=nativo||g[0];
g.forEach(function(w){
if(w===scelto)return;
if(!w.classList.contains('ws-dup')){
w.classList.add('ws-dup');
console.warn('[wow-pdp] gruppo posizione stampa duplicato nascosto');
}
w.style.setProperty('display','none','important');
});
return scelto;
}
function gruppoTaglie(){
var box=document.querySelector('.ws-sizes');
return box?box.closest('.selector-wrapper'):null;
}
/* Colore e Taglia stanno dentro #bcpo, il cui CSS è scoped: non li spostiamo.
   Portiamo il nostro gruppo dentro, subito prima di Taglia. */
function riordina(w){
var taglie=gruppoTaglie();
if(!taglie||taglie===w||taglie.previousElementSibling===w)return;
var padre=taglie.parentNode;
if(padre)padre.insertBefore(w,taglie);
}
function applica(){
var w=gruppo();if(!w)return;
var sel=w.querySelector('select:not(.ws-dd__sel)');
if(!sel)return;
riordina(w);
restoreNativeSelect(w,sel);
}
WSPDP_pass(applica);
window.WSPDP_posizione=applica;
})();

/* ---------------- icone accanto alle etichette dei gruppi ----------------
   Nel tema precedente ogni gruppo VOPO aveva la sua icona SVG prima del
   titolo: la rimettiamo riconoscendo il gruppo dal titolo. */
(function(){
var CDN='https://cdn.shopify.com/s/files/1/0555/0601/0321/files/';
/* titolo -> file icona (l'ordine conta: vince la prima corrispondenza) */
var ICONE=[
[/materiale|tessuto|grammatura/i,'fabric.svg?v=1772452690'],
[/taglia|size/i,'ruler.svg?v=1772452690'],
[/colore|colour/i,'palette.svg?v=1772452690'],
[/posizion[ei] stampa|lati di stampa|stampa su/i,'gps.svg?v=1773436825'],
[/lavorazion|rifinitur|finitur/i,'scissors.svg?v=1772452690'],
[/dimension|formato|misura/i,'ruler.svg?v=1772452690'],
[/quantit/i,'stack.svg?v=1772452690'],
[/fissaggio|occhiell|asol/i,'hook.svg?v=1772452690']
];
function file(titolo){
for(var i=0;i<ICONE.length;i++)if(ICONE[i][0].test(titolo))return ICONE[i][1];
return null;
}
function applica(){
document.querySelectorAll('.bcpo-label label').forEach(function(lab){
var t=lab.querySelector('.bcpo-title');
if(!t||t.dataset.wsIconDone)return;
var f=file(t.textContent||'');
t.dataset.wsIconDone='1';
if(!f)return;
if(lab.querySelector('.ws-bcpo-icon'))return;
var sp=document.createElement('span');
sp.className='ws-bcpo-icon';
var img=document.createElement('img');
img.src=CDN+f;
img.alt='';img.loading='lazy';img.decoding='async';
img.width=20;img.height=20;
img.className='ws-bcpo-icon__img';
/* se il file non esiste nella libreria disegniamo l'icona a mano */
img.addEventListener('error',function(){
img.remove();
sp.innerHTML='<svg viewBox="0 0 24 24" class="ws-bcpo-icon__svg" aria-hidden="true"><path d="M8 3.6 11.2 2q.8 1.5 1.6 0L16 3.6 18 7l-2.6 1.1V21H8.6V8.1L6 7Z"/><circle cx="10.2" cy="11.4" r="1.6"/></svg>';
},{once:true});
sp.appendChild(img);
lab.insertBefore(sp,lab.firstChild);
});
}
WSPDP_pass(applica);
window.WSPDP_icone=applica;
})();

/* ---------------- spedizione gratuita oltre la soglia ----------------
   Il terzo punto dell'hero mostra "Spedizione GRATUITA" solo quando il totale
   supera la soglia impostata; sotto, resta il testo normale. */
(function(){
function cents(txt){
var m=(txt||'').replace(/\s/g,'').match(/([\d.]+)[,.](\d{2})/);
if(!m)return 0;
return Math.round(parseFloat(m[1].replace(/\./g,''))*100)+ +m[2];
}
/* nota nel riepilogo: compare solo quando il totale raggiunge la soglia.
   Funziona anche se lo snippet Liquid in pagina è ancora quello vecchio, cioè
   un semplice <p class="ship"> senza attributi: la soglia si ricava dal punto
   nell'hero, altrimenti 99 €. */
function nota(){
var n=document.querySelector('[data-ws-ship-note]')||document.querySelector('.wow-pdp-kit .ship');
if(!n)return;
n.setAttribute('data-ws-ship-note','');
var min=parseInt(n.getAttribute('data-ws-ship-min'),10)||0;
if(!min){
var hero=document.querySelector('[data-ws-ship-min]:not([data-ws-ship-note])');
min=(hero&&parseInt(hero.getAttribute('data-ws-ship-min'),10))||9900;
n.setAttribute('data-ws-ship-min',min);
}
var el=document.getElementById('sum-tot')||document.getElementById('bar-tot');
var tot=cents(el&&el.textContent);
var mostra=!!(min&&tot>=min);
if(n.hidden!==!mostra)n.hidden=!mostra;
/* il CSS del tema può ignorare l'attributo hidden */
var d=mostra?'':'none';
if(n.style.display!==d)n.style.setProperty('display',d||'block',mostra?'':'important');
}
function applica(){
nota();
var li=document.querySelector('[data-ws-ship-min]:not([data-ws-ship-note])');if(!li)return;
var min=parseInt(li.getAttribute('data-ws-ship-min'),10)||0;
var el=document.getElementById('bar-tot')||document.getElementById('hero-now');
var tot=cents(el&&el.textContent);
var lab=li.querySelector('[data-ws-ship-label]')||li;
var txt=(min&&tot>=min)?li.getAttribute('data-ws-ship-free'):li.getAttribute('data-ws-ship-else');
if(txt&&lab.textContent!==txt)lab.textContent=txt;
li.classList.toggle('is-free',!!(min&&tot>=min));
}
WSPDP_pass(applica);
window.WSPDP_ship=applica;
})();

/* ---------------- mobile: riepilogo in popup, CTA in fondo alle card ----------------
   Su mobile lo step 4 non è una card in colonna: resta fuori dal flusso e si
   apre come foglio dal basso. La barra fissa mostra solo totale e risparmio,
   il pulsante che aggiunge al carrello sta in fondo alle card. */
(function(){
var MQ=window.matchMedia('(max-width:899px)');
var form=document.getElementById('ws-form');if(!form)return;
var wz=form.classList.contains('wz')?form:form.querySelector('.wz')||form;
var panel=form.querySelector('.panel[data-step="4"]');if(!panel)return;

var bg=document.createElement('div');
bg.className='ws-recap-bg';
bg.setAttribute('hidden','');
document.body.appendChild(bg);

/* il foglio va portato in cima al documento: dentro il form un antenato crea un
   contesto di impilamento e la velatura finiva sopra al riepilogo */
if(bg.parentNode!==panel.parentNode)panel.parentNode.insertBefore(bg,panel);
function apri(v){
panel.classList.toggle('recap-on',v);
wz.classList.toggle('recap-open',v);
if(v)bg.removeAttribute('hidden');else bg.setAttribute('hidden','');
document.documentElement.style.overflow=v?'hidden':'';
if(v&&window.WSPDP&&WSPDP.paint)WSPDP.paint();
}
bg.addEventListener('click',function(){apri(false)});
document.addEventListener('keydown',function(e){if(e.key==='Escape')apri(false)});

/* chiusura dentro il foglio */
if(!panel.querySelector('.ws-recap-close')){
var x=document.createElement('button');
x.type='button';
x.className='ws-recap-close';
x.setAttribute('data-ws-clean','1');
x.setAttribute('aria-label','Chiudi il riepilogo');
x.textContent='✕';
x.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();apri(false)});
panel.insertBefore(x,panel.firstChild);
}

/* link per aprirlo, sopra la CTA in fondo alle card */
function link(){
if(!MQ.matches)return;
var mirror=form.querySelector('.bar-inline');
if(!mirror||form.querySelector('.ws-recap-open'))return;
var a=document.createElement('button');
a.type='button';
a.className='ws-recap-open';
a.setAttribute('data-ws-clean','1');
a.textContent='Vedi il riepilogo';
a.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();apri(true)});
mirror.parentNode.insertBefore(a,mirror);
}
WSPDP_pass(link);
window.WSPDP_recap=apri;
MQ.addEventListener&&MQ.addEventListener('change',function(){if(!MQ.matches)apri(false)});
})();
